import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import VersionCard from "../components/VersionCard";
import Gallery from "../components/Gallery";
import { useSearch } from "../context/SearchContext";

export default function Home() {
  const navigate = useNavigate();
  const { query } = useSearch();
  const [indexData, setIndexData] = useState(null);

  useEffect(() => {
    fetch("/images/index.json")
      .then((res) => res.json())
      .then((data) => setIndexData(data))
      .catch((err) => console.error("Error loading index.json:", err));
  }, []);

  const filteredImages = useMemo(() => {
    if (!indexData) return [];
    const q = query.trim().toLowerCase();
    if (!q) return [];
    const terms = q.split(/\s+/);
    return indexData
      .filter((item) => {
        const hay = (
          (item.filename || "") +
          " " +
          (item.url || "") +
          " " +
          (item.version || "")
        ).toLowerCase();
        return terms.every((t) => hay.includes(t));
      })
      .map((item) => ({
        url: item.url,
        filename:
          item.filename ||
          (item.url ? item.url.split("/").pop() : "unknown_filename"),
      }));
  }, [indexData, query]);

  if (!indexData) {
    return <div>Loading...</div>;
  }

  // Exclude vforeign and visps entirely from the normal list
  const uniqueVersions = [...new Set(indexData.map((item) => item.version))].filter(
    (v) => v !== "vforeign" && v !== "visps"
  );

  const handleAboutClick = () => navigate("/about");
  const handleGrowClick = () => navigate("/grow-the-collection");
  const isSearching = query && query.trim();

  return (
    <div className="home-container">
      {isSearching ? (
        <>
          <h2 style={{ textAlign: "center", marginTop: "1rem" }}>
            Search results for “{query.trim()}”
          </h2>
          {filteredImages.length > 0 ? (
            <Gallery images={filteredImages} />
          ) : (
            <div style={{ marginTop: 0 }}>No images found.</div>
          )}
        </>
      ) : (
        <div className="home-grid">
          {uniqueVersions.map((versionName, idx) => {
            if (versionName === "Unknown") {
              return (
                <React.Fragment key={idx}>
                  <VersionCard versionName={versionName} />
                  {/* Foreign AOL Disks card */}
                  <div
                    className="version-card"
                    onClick={() => navigate("/version/vforeign")}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={
                        indexData.find(
                          (img) => img.version === "vforeign" && img.favorite
                        )?.url ||
                        indexData.find(
                          (img) => img.version === "vforeign" && img.preview
                        )?.url ||
                        indexData.find((img) => img.version === "vforeign")?.url ||
                        "/images/vforeign/foreign_placeholder.jpg"
                      }
                      alt="Foreign AOL Disks"
                      className="version-image"
                    />
                    <h3
                      className="version-title"
                      style={{ textAlign: "center" }}
                    >
                      Foreign
                      <br />
                      <span style={{ fontSize: "0.85em", color: "#888" }}>
                        (Under Construction)
                      </span>
                    </h3>
                  </div>
                  {/* Other ISPs card */}
                  <div
                    className="version-card"
                    onClick={() => navigate("/version/visps")}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={
                        indexData.find(
                          (img) => img.version === "visps" && img.favorite
                        )?.url ||
                        indexData.find(
                          (img) => img.version === "visps" && img.preview
                        )?.url ||
                        indexData.find((img) => img.version === "visps")?.url ||
                        "/images/Other_ISPs/other_isps_placeholder.jpg"
                      }
                      alt="Other ISPs"
                      className="version-image"
                    />
                    <h3
                      className="version-title"
                      style={{ textAlign: "center" }}
                    >
                      Other ISPs
                      <br />
                      <span style={{ fontSize: "0.85em", color: "#888" }}>
                        (Coming Soon!)
                      </span>
                    </h3>
                  </div>
                </React.Fragment>
              );
            }
            return <VersionCard key={idx} versionName={versionName} />;
          })}

          {/* About Card */}
          <div
            className="version-card"
            onClick={handleAboutClick}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/about_logo.jpg"
              alt="About AOL Collecting"
              className="version-image"
            />
            <h3 className="version-title">About AOL Collecting</h3>
          </div>

          {/* Grow The Collection Card */}
          <div
            className="version-card"
            onClick={handleGrowClick}
            style={{ cursor: "pointer" }}
          >
            <img
              src="/images/v7/v7_happyface_tin_1000hrs_1916.JPG"
              alt="Grow The Collection!"
              className="version-image"
            />
            <h3 className="version-title">Grow The Collection!</h3>
          </div>
        </div>
      )}
    </div>
  );
}
